import { render } from "./EditableAI.vue?vue&type=template&id=0a1c234e&lang=true"
import script from "./EditableAI.vue?vue&type=script&lang=js"
export * from "./EditableAI.vue?vue&type=script&lang=js"

import "./EditableAI.vue?vue&type=style&index=0&id=0a1c234e&lang=css"
script.render = render

export default script